import { render, staticRenderFns } from "./ReviewWait.vue?vue&type=template&id=1c48a759&scoped=true&"
import script from "./ReviewWait.vue?vue&type=script&lang=js&"
export * from "./ReviewWait.vue?vue&type=script&lang=js&"
import style0 from "./ReviewWait.vue?vue&type=style&index=0&id=1c48a759&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48a759",
  null
  
)

export default component.exports